import { useTravelSearchContext } from '../../context/TravelSearchProvider'
import { UseTravelDatesResult, TravelDatesResponse } from './traveldates-types'

export const useTravelDates = (): UseTravelDatesResult => {
  const { state } = useTravelSearchContext()
  return {
    isTravelDatesLoading: state.travelDatesApiLoading ?? (!state.outboundTravelDates || (!state.isOneWay && !state.homeboundTravelDates)),
    outboundTravelDates: state.outboundTravelDates ?? emptyTravelDates,
    homeboundTravelDates: state.homeboundTravelDates,
    selectedOutboundDate: state.selectedDates?.outboundDate,
    selectedHomeboundDate: state.selectedDates?.homeboundDate,
  }
}

const emptyTravelDates: TravelDatesResponse = {
  disabledDates: [],
  dates: { fromDate: new Date().toString(), toDate: new Date().toString() },
  defaultDate: '',
  offerDates: [],
}
